import React, { Component } from "react";

import { Wrapper, Copy } from "app/NativeComponents/common";

class MessageHeader extends Component {
  render() {
    const { message_header_text, colors } = this.props;
    if (!!message_header_text) {
      return (
        <Wrapper
          style={{
            justifyContent: "center",
            alignItems: "center",
            padding: 5
          }}
        >
          <Wrapper
            style={{
              maxWidth: 250
            }}
          >
            <Copy
              style={{
                textAlign: "center",
                color: colors.light_text_color,
                fontSize: 10
              }}
            >
              {message_header_text}
            </Copy>
          </Wrapper>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

export default MessageHeader;
